angular
  .module('contrast.constants', [])
  .constant('REFRESH_DELAY', {
    shortDelay: 5000,
    mediumDelay: 15000,
    longDelay: 30000
  })
  .constant('AUTH_MODE', {
    mode: {
      DB: 'DB',
      LDAP: 'LDAP',
      AD: 'AD',
      SAML: 'SAML',
      HTTP_HEADER: 'HTTP_HEADER'
    }
  })
  .constant('APP_IMPORTANCE_RANKING', [
    {
      value: 4,
      name: 'Critical',
      translationId: 'title_appImportanceLevelCritical'
    },
    {
      value: 3,
      name: 'High',
      translationId: 'title_appImportanceLevelHigh'
    },
    {
      value: 2,
      name: 'Medium',
      translationId: 'title_appImportanceLevelMedium'
    },
    {
      value: 1,
      name: 'Low',
      translationId: 'title_appImportanceLevelLow'
    },
    {
      value: 0,
      name: 'Unimportant',
      translationId: 'title_appImportanceLevelUnimportant'
    }
  ])
  .constant('DEPLOYMENT_MODE', {
    PROD: 'prod',
    SAAS: 'saas'
  })
  .constant('ATTACK_TYPE', {
    AUTOMATED: 'AUTOMATED',
    MANUAL: 'MANUAL'
  })
  .constant('ATTACK_STATUS', {
    PROBED: { value: 'PROBED', name: 'PROBED' },
    PROBED_PERIMETER: { value: 'PROBED_PERIMETER', name: 'PROBED (P)' },
    BLOCKED: { value: 'BLOCKED', name: 'BLOCKED' },
    BLOCKED_PERIMETER: { value: 'BLOCKED_PERIMETER', name: 'BLOCKED (P)' },
    EXPLOITED: { value: 'EXPLOITED', name: 'EXPLOITED' },
    SUSPICIOUS: { value: 'SUSPICIOUS', name: 'SUSPICIOUS' }
  })
  .constant('RASP_TIME_UNIT', {
    SECOND: 'SECOND',
    MINUTE: 'MINUTE',
    HOUR: 'HOUR',
    DAY: 'DAY'
  })
  .constant('CLOSED_STATUS', ['Remediated', 'Not a Problem', 'Fixed'])
  .constant('STATUS_LIST', [
    { value: 'REPORTED', name: 'Reported', group: 'OPEN', rankOrder: 0 },
    { value: 'CONFIRMED', name: 'Confirmed', group: 'OPEN', rankOrder: 1 },
    { value: 'SUSPICIOUS', name: 'Suspicious', group: 'OPEN', rankOrder: 2 },
    { value: 'REMEDIATED', name: 'Remediated', group: 'CLOSED', rankOrder: 3 },
    { value: 'FIXED', name: 'Fixed', group: 'CLOSED', rankOrder: 4 },
    {
      value: 'NOT_A_PROBLEM',
      name: 'Not a problem',
      group: 'CLOSED',
      rankOrder: 5
    },
    {
      value: 'AUTO_REMEDIATED',
      name: 'Remediated - Auto-verified',
      group: 'CLOSED',
      rankOrder: 6
    }
  ])
  .constant('TEAMSERVER_SCORING_TYPE', {
    OVERALL: {
      DEFAULT: 'DEFAULT',
      CUSTOM_ONLY: 'CUSTOM_ONLY'
    },
    LIBRARY: {
      DEFAULT: 'DEFAULT',
      VULN: 'VULN'
    }
  })
  .constant('ROLE_NOACCESS', {
    group_id: 0,
    name: 'no_access',
    roleType: 'NO_ACCESS'
  })
  .constant(
    'URL_VALIDATOR_EXPRESSION',
    '/(http|https)://(w+:{0,1}w*)?(S+)(:[0-9]+)?(/|/([w#!:.?+=&%!-/]))?/'
  )
  .constant('SERVER_ENVIRONMENTS', {
    DEV: { id: 'DEVELOPMENT', name: 'Development' },
    QA: { id: 'QA', name: 'QA' },
    PROD: { id: 'PRODUCTION', name: 'Production' }
  })
  .constant('NOTIFICATION_STATUS_TYPE', {
    RECEIVED: 'RECEIVED',
    READ: 'READ'
  })
  .constant('TSV_DEVICE_TYPES', ['Android', 'iPhone', 'Blackberry'])
  .constant('NOTIFICATION_TYPE', {
    NEW_ATTACK: 'NEW_ATTACK',
    NEW_VULNERABILITY: 'NEW_VULNERABILITY',
    NEW_VULNERABLE_LIBRARY: 'NEW_VULNERABLE_LIBRARY',
    NEW_SCA_VULNERABLE_LIBRARY: 'NEW_SCA_VULNERABLE_LIBRARY',
    SERVER_OFFLINE: 'SERVER_OFFLINE',
    NEW_VULNERABILITY_COMMENT: 'NEW_VULNERABILITY_COMMENT',
    NEW_ASSET: 'NEW_ASSET',
    SERVER_MESSAGES: 'SERVER_MESSAGES',
    EXPIRING_LICENSES: 'EXPIRING_LICENSES',
    VULNERABILITY_CHANGESTATUS_OPEN: 'VULNERABILITY_CHANGESTATUS_OPEN',
    VULNERABILITY_CHANGESTATUS_CLOSED: 'VULNERABILITY_CHANGESTATUS_CLOSED',
    SAST_FAILED_SCAN: 'SAST_FAILED_SCAN'
  })
  .constant('INTEGRATION_TYPE', {
    JIRA: 'JIRA',
    VSTS: 'VSTS',
    GITHUB: 'GITHUB',
    AGILE_CENTRAL: 'AGILE_CENTRAL',
    SLACK: 'SLACK',
    MICROSOFTTEAMS: 'MICROSOFTTEAMS',
    NEW_MICROSOFTTEAMS: 'NEW_MICROSOFTTEAMS',
    VICTOROPS: 'VICTOROPS',
    PAGERDUTY: 'PAGERDUTY',
    GENERIC: 'GENERIC',
    JENKINS: 'JENKINS',
    UNSUPPORTED: 'UNSUPPORTED'
  })
  .constant('NOTIFICATION_CHANNELS', {
    DATABASE: 'DATABASE',
    EMAIL: 'EMAIL',
    WEBHOOK: 'WEBHOOK'
  })
  .constant('NOTIFICATION_TYPE_OPTIONS', {
    ALL: 'ALL',
    LIBRARY: 'LIBRARY'
  })
  .constant('NOTIFICATION_ASSET_TYPE', {
    APPLICATION: 'APPLICATION',
    SERVER: 'SERVER'
  })
  .constant('RULE_SEVERITY', {
    CRITICAL: 'CRITICAL',
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW',
    NOTE: 'NOTE'
  })
  .constant('SERVER_ENVIRONMENT', {
    DEVELOPMENT: { value: 'DEVELOPMENT', name: 'Development' },
    QA: { value: 'QA', name: 'QA' },
    PRODUCTION: { value: 'PRODUCTION', name: 'Production' }
  })
  .constant('SERVER_ENVIRONMENT_ENUM', ['DEVELOPMENT', 'QA', 'PRODUCTION'])
  .constant('SERVER_ENVIRONMENT_ARRAY', ['Development', 'QA', 'Production'])
  .constant('SERVER_ENVIRONMENT_SELECT', [
    {
      value: 'ALL',
      name: 'All Environments',
      translationId: 'title_allEnvironments'
    },
    {
      value: 'DEVELOPMENT',
      name: 'Development',
      translationId: 'title_serverEnvironmentDevelopment'
    },
    {
      value: 'QA',
      name: 'QA',
      translationId: 'title_serverEnvironmentQualityAssurance'
    },
    {
      value: 'PRODUCTION',
      name: 'Production',
      translationId: 'title_serverEnvironmentProduction'
    }
  ])
  .constant('LOG_LEVELS', ['ERROR', 'WARN', 'INFO', 'DEBUG', 'TRACE'])
  .constant('APPLICATION_IMPORTANCE_LIST', [
    { value: 'CRITICAL', name: 'Critical' },
    { value: 'HIGH', name: 'High' },
    { value: 'MEDIUM', name: 'Medium' },
    { value: 'LOW', name: 'Low' },
    { value: 'UNIMPORTANT', name: 'Unimportant' }
  ])
  .constant('APPLICATION_IMPORTANCE_ENUM', {
    CRITICAL: 'detail_attacksMonitor_appImportanceCritical',
    HIGH: 'detail_attacksMonitor_appImportanceHigh',
    MEDIUM: 'detail_attacksMonitor_appImportanceMedium',
    LOW: 'detail_attacksMonitor_appImportanceLow',
    UNIMPORTANT: 'detail_attacksMonitor_appImportanceUnimportant'
  })
  .constant('RULE_SEVERITY_LIST', [
    {
      value: 'CRITICAL',
      name: 'Critical',
      rankOrder: 0,
      translationId: 'title_vulnSeverityTypeCritical'
    },
    {
      value: 'HIGH',
      name: 'High',
      rankOrder: 1,
      translationId: 'title_vulnSeverityTypeHigh'
    },
    {
      value: 'MEDIUM',
      name: 'Medium',
      rankOrder: 2,
      translationId: 'title_vulnSeverityTypeMedium'
    },
    {
      value: 'LOW',
      name: 'Low',
      rankOrder: 3,
      translationId: 'title_vulnSeverityTypeLow'
    },
    {
      value: 'NOTE',
      name: 'Note',
      rankOrder: 4,
      translationId: 'title_vulnSeverityTypeNote'
    }
  ])
  .constant('RULE_SEVERITY_ENUM', {
    CRITICAL: 'Critical',
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low',
    NOTE: 'Note'
  })
  .constant('TIME_SERIES_DATES', [
    {
      text: 'Last 7 Days',
      tooltip: '',
      value: 'WEEK'
    },
    {
      text: 'Last 30 Days',
      tooltip: '',
      value: 'MONTH'
    },
    {
      text: 'Last 12 Months',
      tooltip: 'Last calendar year',
      value: 'YEAR'
    }
  ])
  .constant('TIME_SERIES_DATES_TODAY', [
    {
      text: 'Last 7 Days',
      tooltip: '',
      value: 'WEEK',
      includeToday: true
    },
    {
      text: 'Last 30 Days',
      tooltip: '',
      value: 'MONTH',
      includeToday: true
    },
    {
      text: 'Last 12 Months',
      tooltip: 'Last calendar year',
      value: 'YEAR',
      includeToday: true
    }
  ])
  .constant('TRACE_BREAKDOWN_TYPES', ['Severity', 'Status', 'Type'])
  .constant('ATTACK_BREAKDOWN_TYPES', ['Status', 'Type'])
  .constant('TIME_SERIES_SELECT', [
    {
      text: 'Last 7 Days',
      tooltip: '',
      includeToday: true
    },
    {
      text: 'Last 30 Days',
      tooltip: '',
      includeToday: true
    },
    {
      text: 'Last 12 Months',
      tooltip: 'Last calendar year',
      includeToday: true
    }
  ])
  .constant('RULE_SEVERITY_ORDER', [
    'CRITICAL',
    'HIGH',
    'MEDIUM',
    'LOW',
    'NOTE'
  ])
  .constant('EXPORT_TYPES', {
    CSV: 'CSV',
    XML: 'XML'
  })
  .constant('PROTECTION_MODES', [
    {
      value: 'OFF',
      short: 'title_protectMode_off',
      label: 'title_protectMode_off'
    },
    {
      value: 'MONITORING',
      short: 'title_protectMode_monitor',
      label: 'title_protectMode_monitor'
    },
    {
      value: 'BLOCKING',
      short: 'title_protectMode_block',
      label: 'title_protectMode_block'
    },
    {
      value: 'BLOCKING_PERIMETER',
      short: 'title_protectMode_blockAtPerimeter_short',
      label: 'title_protectMode_blockAtPerimeter'
    },
    {
      value: 'MONITOR_PERIMETER',
      short: 'title_protectMode_monitorAtPerimeter_short',
      label: 'title_protectMode_monitorAtPerimeter'
    }
  ])
  .constant('PROTECTION_MODES_ORDINAL', [
    'OFF',
    'MONITORING',
    'BLOCKING',
    'BLOCKING_PERIMETER',
    'MONITOR_PERIMETER'
  ])
  .constant('PROTECTION_MODES_BASE', [
    { value: 'OFF', label: 'title_protectMode_off' },
    { value: 'MONITORING', label: 'title_protectMode_monitor' },
    { value: 'BLOCKING', label: 'title_protectMode_block' }
  ])
  .constant('PROTECTION_MODES_SELECT', [
    { value: 0, label: 'OFF' },
    { value: 1, label: 'MONITOR' },
    { value: 4, label: 'MONITOR (P)' },
    { value: 2, label: 'BLOCK' },
    { value: 3, label: 'BLOCK (P)' },
    { value: 4, label: 'MONITOR (P)' }
  ])
  .constant('CVE_SCORE_SEVERITY', {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW'
  })
  .constant('ROLES', {
    admin: 'Admin',
    rules_admin: 'Rules Admin',
    edit: 'Edit',
    view: 'View',
    org_auditor: 'Auditor'
  })
  .constant('ORG_ROLES', {
    ADMIN: 'admin',
    RULES_ADMIN: 'rules_admin',
    EDIT: 'edit',
    VIEW: 'view',
    ORG_AUDITOR: 'Auditor'
  })
  .constant('SYSTEM_ROLES', {
    OBSERVER: 'observer',
    SYSTEM_ADMIN: 'system_admin',
    SERVER_ADMIN: 'server_admin',
    SUPERADMIN: 'superadmin'
  })
  .constant('SUPERADMIN_ROLES_LIST', [
    { value: 'SERVER_ADMIN', label: 'ServerAdmin' },
    { value: 'SUPERADMIN', label: 'SuperAdmin' }
  ])
  .constant('SUPERADMIN_ROLES', {
    SUPERADMIN: 'SUPERADMIN',
    SERVER_ADMIN: 'SERVER_ADMIN'
  })
  .constant('NONE_OPTION', {
    SUPERADMIN_ROLE: { value: '', label: 'None' },
    ORGANIZATION: { value: '', label: 'None' }
  })
  .constant('ORGANIZATION_NONE', [{ value: '', label: 'None' }])
  .constant('ROLES_LIST', [
    { value: 'admin', label: 'Admin' },
    { value: 'rules_admin', label: 'Rules Admin' },
    { value: 'edit', label: 'Edit' },
    { value: 'view', label: 'View' },
    { value: 'no_access', label: 'No Access' },
    { value: 'org_auditor', label: 'Auditor' }
  ])
  .constant('TS_BASE_URL', '/Contrast/api/ng')
  .constant('SKIP_HATEOAS_LINK', 'skip_links')
  .constant('TEAMSERVER_PREFERENCES', {
    LICENSING_OVERRIDE: 'license.auto.override',
    LICENSING_ASSESSMENT: 'license.auto.assessment',
    LICENSING_PROTECTION: 'license.auto.protection',
    LICENSING_PROTECTION_ENVIRONMENTS: 'license.auto.environment'
  })
  .constant('INTEGRATION_APPLICATION_OPTIONS', [
    { value: 'ID', name: 'Application names' },
    { value: 'IMPORTANCE', name: 'Application importance levels' },
    { value: 'APP_TAGS', name: 'Application tags' }
  ])
  .constant('FILTER_GROUPS', {
    SEVERITY: 'SEVERITY',
    VULNERABILITY_RULES: 'ASSESS RULES',
    IMPORTANCE: 'IMPORTANCE',
    APPLICATIONS: 'APPLICATIONS',
    SERVERS: 'SERVERS',
    ENVIRONMENT: 'ENVIRONMENT',
    UNLICENSED: 'UNLICENSED',
    LICENSED: 'LICENSED',
    APP_TAGS: 'APPLICATION TAGS',
    BUILD_NUMBERS: 'BUILD NUMBERS',
    SERVER_TAGS: 'SERVER TAGS',
    VULN_TAGS: 'VULNERABILITY TAGS',
    SECURITY_STANDARDS: 'SECURITY STANDARDS',
    COMPLIANCE_POLICY: 'COMPLIANCE POLICY',
    REMEDIATION_POLICY: 'REMEDIATION POLICY'
  })
  .constant('VULNERABILITY_REPORT_RANGES', [
    {
      keycode: 'week',
      label: 'Last 7 Days',
      momentConfig: { val: 7, period: 'days' },
      translationId: 'detail_lastSevenDays'
    },
    {
      keycode: 'month',
      label: 'Last 30 Days',
      momentConfig: { val: 30, period: 'days' },
      translationId: 'detail_lastThirtyDays'
    },
    {
      keycode: 'quarter',
      label: 'Last 12 Weeks',
      momentConfig: { val: 12, period: 'weeks' },
      translationId: 'detail_lastTwelveWeeks'
    },
    {
      keycode: 'year',
      label: 'Last 12 Months',
      momentConfig: { val: 12, period: 'months' },
      translationId: 'detail_lastTwelveMonths'
    }
  ])
  .constant('VULNERABILITY_REPORT_TYPE', {
    NEW: 'NEW',
    TOTAL: 'TOTAL'
  })
  .constant('USER_PERMISSION_TYPE', {
    SYSTEM: 'SYSTEM',
    ORGANIZATION: 'ORGANIZATION'
  })
  .constant('VULNERABILITY_REPORT_RANGES_DASHBOARD', [
    {
      keycode: 'week',
      label: 'Last 7 Days',
      translationId: 'detail_lastSevenDays',
      group: 'New',
      tooltip: ''
    },
    {
      keycode: 'month',
      label: 'Last 30 Days',
      translationId: 'detail_lastThirtyDays',
      group: 'New',
      tooltip: ''
    },
    {
      keycode: 'year',
      label: 'Last 12 Months',
      translationId: 'detail_lastTwelveMonths',
      group: 'New',
      tooltip: 'Last calendar year'
    },
    {
      keycode: 'week',
      label: 'Last 7 Days',
      translationId: 'detail_lastSevenDays',
      group: 'Total',
      tooltip: ''
    },
    {
      keycode: 'month',
      label: 'Last 30 Days',
      translationId: 'detail_lastThirtyDays',
      group: 'Total',
      tooltip: ''
    },
    {
      keycode: 'year',
      label: 'Last 12 Months',
      translationId: 'detail_lastTwelveMonths',
      group: 'Total',
      tooltip: 'Last calendar year'
    }
  ])
  .constant('RASP_TIME_UNITS', ['SECOND', 'MINUTE', 'HOUR', 'DAY'])
  .constant('GLOBAL_EVENTS', {
    ATTACK_EVENTS_DATE_CHANGE: 'attackevents:date',
    AVATAR_UPDATE: 'avatar.update'
  })
  .constant('SCORE_TYPE', {
    OVERALL: 'OVERALL',
    LIBRARY: 'LIBRARY',
    CUSTOM_CODE: 'CUSTOM_CODE',
    PROTECT: 'PROTECT'
  })
  .constant('USER_STATUS', {
    ACTIVE: {
      value: 0,
      name: 'Active'
    },
    LOCKED: {
      value: 1,
      name: 'Locked'
    },
    INACTIVE: {
      value: 2,
      name: 'Inactive'
    },
    UNACTIVATED: {
      value: 3,
      name: 'Waiting for Activation'
    }
  })
  /*TODO i18n-042 [account] I18N_LANGUAGES (text) in dropdown are showed in english because angular-translate dependency can't be applied in an angular CONSTANT. Files to review: Constants.js, Profile.html.*/
  .constant('I18N_LANGUAGES', [
    {
      value: 'en',
      text: 'English',
      translationId: 'detail_language_english'
    },
    {
      value: 'es',
      text: 'Spanish',
      translationId: 'detail_language_spanish',
      isBeta: true
    },
    {
      value: 'ja',
      text: 'Japanese',
      translationId: 'detail_language_japanese'
    }
  ])
  .constant('LOGIN_EVENTS', {
    FOCUS_USERNAME: 'focus:username',
    FOCUS_PASSWORD: 'focus:password'
  })
  .constant('APPLICATION_LICENSES', {
    LICENSED: 'Licensed',
    UNLICENSED: 'Unlicensed',
    READONLY: 'ReadOnly'
  })
  .constant('TAG_TYPE', {
    FREE_FORM: 'FREE_FORM',
    SMART_TAG: 'SMART_TAG',
    APPLICATION_VERSION: 'APPLICATION_VERSION'
  })
  .constant('GROUP_TYPES', [
    { id: 1, name: 'Organizational' },
    { id: 0, name: 'System' }
  ])
  .constant('GROUP_TYPES_ENUM', {
    ORGANIZATIONAL: 1,
    SYSTEM: 0
  })
  .constant('USER_STATUS_ARRAY', [
    'Active',
    'Locked',
    'Inactive',
    'Waiting for Activation'
  ])
  .constant('GROUP_TYPES_LABEL', {
    SYSTEM: 'Sys',
    ORGANIZATIONAL: 'Org'
  })
  .constant('JIRA_FIELD_TYPES', {
    PRIORITY: 'priority',
    ARRAY: 'array',
    STRING: 'string',
    NUMBER: 'number',
    DATETIME: 'datetime',
    DATE: 'date',
    TIME_TRACKING: 'timetracking',
    ANY: 'any',
    URL: 'url',
    USER: 'user',
    NAME: 'name',
    ID: 'id',
    MULTISELECT: 'multiselect',
    MULTICHECKBOXES: 'multicheckboxes',
    MULTIUSERPICKER: 'multiuserpicker',
    SELECT: 'select',
    RADIOBUTTONS: 'radiobuttons',
    ISSUELINK: 'issuelink',
    CASCADING_SELECT: 'option-with-child'
  })
  .constant('AGILE_CENTRAL_FIELD_TYPES', {
    REFERENCE_ARRAY: 'array:reference',
    ARRAY: 'array',
    INTEGER: 'integer',
    REFERENCE: 'reference',
    STRING: 'string',
    BOOLEAN: 'boolean'
  })
  .constant('UNKNOWN_SOURCE_KEY', '__unknown__attack__source__')
  .constant('LOCALIZATION', {
    BETA_LOCALES: ['es'],
    DEFAULT_LOCALE: 'en'
  })
